import { motion } from "framer-motion";
import { fadeUp } from "@/lib/animations";

export default function CtaSection() {
  return (
    <section className="py-24 bg-gradient-to-br from-purple-600 to-purple-700 text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="ctaGrid" width="20" height="20" patternUnits="userSpaceOnUse">
              <path d="M 20 0 L 0 0 0 20" fill="none" stroke="white" strokeWidth="0.5" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#ctaGrid)" />
        </svg>
      </div>
      
      {/* Accent circles */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-green-400 rounded-full opacity-10 -translate-x-1/2 -translate-y-1/2"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-purple-400 rounded-full opacity-20 translate-x-1/3 translate-y-1/3"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-5xl mx-auto">
          <div className="bg-white/10 backdrop-blur-sm p-10 md:p-16 rounded-2xl shadow-xl border border-white/20">
            <div className="flex flex-col md:flex-row gap-12 items-center">
              <div className="w-full md:w-3/5">
                <motion.h2 
                  className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6"
                  variants={fadeUp}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true }}
                >
                  Ready to transform your <span className="text-green-300">social media</span> with AI?
                </motion.h2>
                
                <motion.p 
                  className="text-lg mb-8 opacity-90"
                  variants={fadeUp}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true }}
                  custom={1}
                >
                  Get a free analysis of your current content and see how our AI-powered solutions can help you achieve better engagement, higher conversions, and measurable ROI.
                </motion.p>
                
                <motion.div
                  className="flex flex-col sm:flex-row gap-4"
                  variants={fadeUp}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true }}
                  custom={2}
                >
                  <a 
                    href="#contact" 
                    className="px-8 py-4 bg-green-500 text-white font-medium rounded-lg shadow-lg hover:bg-green-600 transition-colors text-center"
                  >
                    Get Your Free Analysis
                  </a>
                  <a 
                    href="#reels" 
                    className="px-8 py-4 bg-white/20 backdrop-blur-sm hover:bg-white/30 text-white font-medium rounded-lg border border-white/30 transition-colors text-center"
                  >
                    View Sample Work
                  </a>
                </motion.div>
              </div>
              
              <div className="w-full md:w-2/5">
                <motion.div
                  className="relative"
                  variants={fadeUp}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true }}
                  custom={1}
                >
                  {/* Stats Card */}
                  <div className="bg-white text-gray-900 p-8 rounded-xl shadow-lg">
                    <h3 className="text-xl font-bold mb-6 text-purple-600">AI-Driven Results</h3>
                    
                    <div className="space-y-6">
                      <div>
                        <div className="flex justify-between mb-2">
                          <span className="font-medium">Engagement Rate</span>
                          <span className="text-green-600 font-bold">+350%</span>
                        </div>
                        <div className="w-full bg-gray-200 rounded-full h-2">
                          <div className="bg-green-500 h-2 rounded-full" style={{ width: '85%' }}></div>
                        </div>
                      </div>
                      
                      <div>
                        <div className="flex justify-between mb-2">
                          <span className="font-medium">Conversion Rate</span>
                          <span className="text-green-600 font-bold">+210%</span>
                        </div>
                        <div className="w-full bg-gray-200 rounded-full h-2">
                          <div className="bg-green-500 h-2 rounded-full" style={{ width: '75%' }}></div>
                        </div>
                      </div>
                      
                      <div>
                        <div className="flex justify-between mb-2">
                          <span className="font-medium">ROI Improvement</span>
                          <span className="text-green-600 font-bold">+180%</span>
                        </div>
                        <div className="w-full bg-gray-200 rounded-full h-2">
                          <div className="bg-green-500 h-2 rounded-full" style={{ width: '65%' }}></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </motion.div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
